<template>
  <div>
    <span class="d-block">Доступные платёжные системы:</span>
    <div class="payment-icons d-flex a-center flex-wrap">
      <component
        :is="icon"
        v-for="(icon, i) in paymentIcons"
        :key="i"
        class="payment-icon"
      />
    </div>
  </div>
</template>

<script>
  import IconApplePay from '@/components/icons/payment-systems/IconApplePay.vue'
  import IconGoogle from '@/components/icons/payment-systems/IconGoogle.vue'
  import IconMaestro from '@/components/icons/payment-systems/IconMaestro.vue'
  import IconMastercard from '@/components/icons/payment-systems/IconMastercard.vue'
  import IconMir from '@/components/icons/payment-systems/IconMir.vue'
  import IconVisa from '@/components/icons/payment-systems/IconVisa.vue'
  import IconSBP from '@/components/icons/payment-systems/IconSBP.vue'

  export default {
    name: 'PaymentTypeIcons',
    components: {
      IconApplePay,
      IconGoogle,
      IconMaestro,
      IconMastercard,
      IconMir,
      IconVisa,
      IconSBP,
    },
    data () {
      return {
        paymentIcons: [
          /* 'IconApplePay',
          'IconGoogle', */
          // 'IconMaestro',
          'IconSBP',
          'IconMastercard',
          'IconMir',
          'IconVisa',
        ],
      }
    },
  }
</script>

<style scoped lang="less">
.payment-icons {
  .payment-icon {
    margin-top: 13px;
    margin-bottom: 15px;
    margin-right: 25px;
  }
}
</style>
